import script from "./TooltipComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipComponent.vue?vue&type=script&setup=true&lang=js"

import "./TooltipComponent.vue?vue&type=style&index=0&id=72f93b0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f93b0d"]])

export default __exports__